import { Link } from '@/global/components/Link'
import { useNotificacoes } from '@/hooks'
import { cn } from '@/lib/utils'
import { BellIcon } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import IconButton from '../../global/components/Button/IconButton'
import { Badge } from '../../global/components/ui/badge'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '../../global/components/ui/dropdown-menu'
import NenhumaNotificacao from './NenhumaNotificacao'
import Notificacao from './Notificacao'

export type StoredNotification = {
    value: number
    module: string
    type: string
    ref: string
    id: string
}

export function CentralNotificacoes() {
    const { pathname } = useLocation()
    const [open, setOpen] = useState(false)

    const hook = useNotificacoes()

    useEffect(() => {
        setOpen(false)
    }, [pathname])

    if (!hook) return null

    const { notifications = [], silentNotifications = [], markAsSeen } = hook

    const notificacoesPrincipais = notifications.filter(n => !n.seen).length,
        notificacoesNaoLidas = Math.min(
            notificacoesPrincipais + silentNotifications.length,
            99,
        )

    return (
        <DropdownMenu open={open} onOpenChange={setOpen}>
            <DropdownMenuTrigger asChild>
                <IconButton
                    size="small"
                    className="dark:text-foreground text-background"
                >
                    <Badge
                        className={cn(
                            'absolute -top-1 -right-1 size-4 rounded-full',
                            'flex items-center justify-center',
                            'p-0 dark:bg-primary bg-background/40',
                        )}
                    >
                        {notificacoesNaoLidas > 0 ? notificacoesNaoLidas : null}
                    </Badge>
                    <BellIcon
                        className={cn('size-6', {
                            'animate-wiggle': notificacoesPrincipais > 0,
                        })}
                    />
                </IconButton>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
                <div
                    className={cn(
                        'flex flex-col overflow-hidden',
                        'w-xs max-w-[calc(100vw-2rem)]',
                        'max-h-[min(calc(100vh-6rem),25rem)] min-h-[min(calc(100vh-6rem),25rem)]',
                    )}
                >
                    <div className="w-full flex items-center justify-between px-1 py-2">
                        <span className="select-none px-2">Notificações</span>
                        <Link
                            className={cn(
                                'text-xs cursor-pointer',
                                'opacity-0 pointer-events-none',
                                'transition-opacity duration-200',
                                {
                                    'opacity-100': notificacoesPrincipais > 0,
                                    'pointer-events-auto':
                                        notificacoesPrincipais > 0,
                                },
                            )}
                            onClick={() => markAsSeen('*')}
                        >
                            Marcar todas como lidas
                        </Link>
                    </div>
                    <DropdownMenuSeparator />
                    <div className="flex flex-1 flex-col max-h-full overflow-y-auto py-2 gap-2 px-1 overflow-x-hidden">
                        {silentNotifications.length > 0 &&
                            silentNotifications.map(n => (
                                <Notificacao key={n.id} data={n} />
                            ))}
                        {notifications.length === 0 ? (
                            <NenhumaNotificacao />
                        ) : (
                            notifications.map(notification => (
                                <Notificacao
                                    key={notification.id}
                                    data={notification}
                                    onMouseEnter={() => {
                                        if (notification.seen) return
                                        markAsSeen(notification.id)
                                    }}
                                />
                            ))
                        )}
                    </div>
                </div>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
